const BASE = {
	API_DEV: {
		fileServer: "http://api.east.hina-gold.com",
		apiLink: "http://fxinpz.com/manager-api/manager",
		// apiLink: "http://localhost:8803/manager",

		// apiLink: "http://192.168.0.55:8803/manager",
		wsLink: "ws://atptsad-api.hina-gold.com/websocket",
		loginLink: "http://front.east.hina-gold.com"
	},
	API_PRO: {
		fileServer: "http://api.east.hina-gold.com",
		apiLink: "https://fxinpz.com/manager-api/manager",
		wsLink: "ws://atptsad-api.hina-gold.com/websocket",
		loginLink: "http://front.east.hina-gold.com"
	},
};


module.exports = {
	fileServer: (process.env.NODE_ENV === 'development') ? BASE.API_DEV.fileServer : BASE.API_PRO.fileServer,
	apiLink: (process.env.NODE_ENV === 'development') ? BASE.API_DEV.apiLink : BASE.API_PRO.apiLink,
	wsLink: (process.env.NODE_ENV === 'development') ? BASE.API_DEV.wsLink : BASE.API_PRO.wsLink,
	loginLink: (process.env.NODE_ENV === 'development') ? BASE.API_DEV.loginLink : BASE.API_PRO.loginLink
};
